
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 40 40"}},[_c('path',{attrs:{"d":"M35.71 7.413l-3.165-3.175L20 16.825 7.455 4.238 4.29 7.413l12.545 12.592L4.29 32.585l3.165 3.177L20 23.173l12.545 12.588 3.165-3.177-12.545-12.579z"}})]);
        };
      

        module.exports = {
          
          render: render,
        };
      